import React, { useEffect, useState } from "react";
import {
  FaList, FaChartBar, FaPhone, FaClock, FaBan, FaCheckCircle, FaRedo,
} from "react-icons/fa";
import { getApiCall } from "../../service/httpCall";
import { API_DASHBOARD_OUTBOUND_CAMPAIGNS_STATS } from "../../service/url";

import { USER_ROLES } from "../../utilities/constant";
import { Storage } from "../../utilities/setting";

/* ─── Single metric chip ─────────────────────────────────────────────────── */
const MetricChip = ({ icon, label, value, accentColor }) => (
  <div
    className="campaign-metric-chip"
    style={{ "--chip-accent": accentColor }}
  >
    <div className="campaign-metric-chip__icon">{icon}</div>
    <div className="campaign-metric-chip__body">
      <div className="campaign-metric-chip__value">{value ?? "—"}</div>
      <div className="campaign-metric-chip__label">{label}</div>
    </div>
  </div>
);

/* ═══════════════════════════════════════════════════════════════════════════
   DashboardCampaignDetails
═══════════════════════════════════════════════════════════════════════════ */
const DashboardCampaignDetails = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);

  useEffect(() => {
    async function checkUserRole() {
      const rawUser = Storage.getItem("user");
      if (!rawUser) { console.error("User not found in Storage"); return null; }
      let user;
      try { user = JSON.parse(rawUser); } catch (e) { console.error("Invalid JSON", e); return null; }
      if (user.role) setLoggedInUserRole(user.role);
    }
    checkUserRole();
  }, []);

  useEffect(() => {
    if (!loggedInUserRole) return;
    if (loggedInUserRole == USER_ROLES.CALL_CENTRE_AGENT) return;
    fetchDashboardStats();
  }, [loggedInUserRole]);

  const fetchDashboardStats = async () => {
    try {
      const response = await getApiCall(API_DASHBOARD_OUTBOUND_CAMPAIGNS_STATS);
      setDashboardData(response?.campaigns || {});
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    }
  };

  const stats = [
    { label: "Total Campaigns",   value: dashboardData?.totalCampaigns,          icon: <FaList />,                                      color: "#6366f1" },
    { label: "This Month",        value: dashboardData?.totalCampaignsThisMonth,  icon: <FaChartBar />,                                  color: "#f97316" },
    { label: "Dialed",            value: dashboardData?.totalProcessed,           icon: <FaPhone style={{ transform: "rotate(100deg)" }} />, color: "#10b981" },
    { label: "Running",           value: dashboardData?.runningCampaigns,         icon: <FaClock />,                                     color: "#a855f7" },
    { label: "Errored",           value: dashboardData?.erroredCampaigns,         icon: <FaBan />,                                       color: "#f43f5e" },
    { label: "Connected",         value: dashboardData?.totalConnected,           icon: <FaCheckCircle />,                               color: "#0ea5e9" },
    { label: "Total Numbers",     value: dashboardData?.totalNos,                 icon: <FaChartBar />,                                  color: "#eab308" },
    { label: "Completed",         value: dashboardData?.completedCampaigns,       icon: <FaChartBar />,                                  color: "#14b8a6" },
  ];

  return (
    <div className="dash-section-card" style={{ marginBottom: 28 }}>
      <div className="dash-section-header">
        <span>Campaign Details</span>
      </div>
      <div className="campaign-metrics-grid">
        {stats.map((item, i) => (
          <MetricChip
            key={i}
            icon={item.icon}
            label={item.label}
            value={item.value}
            accentColor={item.color}
          />
        ))}
      </div>
    </div>
  );
};

export default DashboardCampaignDetails;
